import React from "react";

export const NoAlertsOverlay = ({ containerStyle = {} }) => {
  return (
    <div
      style={{
        position: "relative",
        backgroundColor: "white",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: "1.5rem",
        minHeight: "300px",
        ...containerStyle
      }}
    >
      {/* Bell icon with slash - indicating no alerts */}
      <div
        style={{
          width: "3.5rem",
          height: "3.5rem",
          marginBottom: "1rem",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative"
        }}
      >
        {/* Bell icon */}
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ color: "#e0e0e0" }}
        >
          <path
            d="M12 2C11.2044 2 10.4413 2.31607 9.87868 2.87868C9.31607 3.44129 9 4.20435 9 5V5.29C6.03 6.15 4 8.83 4 12V17L2 19V20H22V19L20 17V12C20 8.83 17.97 6.15 15 5.29V5C15 4.20435 14.6839 3.44129 14.1213 2.87868C13.5587 2.31607 12.7956 2 12 2ZM12 22C13.1 22 14 21.1 14 20H10C10 21.1 10.9 22 12 22Z"
            fill="currentColor"
          />
        </svg>
        
        {/* Slash overlay */}
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%) rotate(-45deg)",
            width: "120%",
            height: "0.25rem",
            backgroundColor: "#ff6b6b",
            borderRadius: "0.125rem"
          }}
        />
      </div>
      
      <p
        style={{
          color: "black",
          fontWeight: "bold",
          fontSize: "20px",
          marginTop: "1rem",
          fontFamily: "Arial, sans-serif",
          textAlign: "center",
          marginBottom: "0.5rem"
        }}
      >
        No Alerts for this Student or Selected Filter
      </p>
      <p
        style={{
          color: "#89CFF0",
          fontSize: "16px",
          marginTop: "0.5rem",
          fontFamily: "Arial, sans-serif",
          textAlign: "center"
        }}
      >
        Try another alert filter
      </p>
      <p
        style={{
          color: "#89CFF0",
          fontSize: "16px",
          marginTop: "0.5rem",
          fontFamily: "Arial, sans-serif",
          textAlign: "center"
        }}
      >
        Try checking out the student's profile or their wellness data
      </p>
    </div>
  );
}; 